import { useLocalObservable } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

interface IQuotedTextPresenter {
  inputPanel: InputPanel;
  quote: Quote | null;
  title: string;
  isForwarding: boolean;
  isQuoteTextMode: boolean;
  onClick(): void;
  endQuote(): void;
}

export function useQuotedTextPresenter(): IQuotedTextPresenter {
  const presenter = useLocalObservable<IQuotedTextPresenter>(() => ({
    get inputPanel(): InputPanel {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    get quote(): Quote | null {
      return presenter.inputPanel.quote || null;
    },

    get title(): string {
      if (presenter.isForwarding && presenter.quote?.group?.isChannel) {
        return presenter.quote?.group?.title;
      }
      return presenter.quote?.senderUser?.avatarTitle || '';
    },

    get isForwarding(): boolean {
      return presenter.quote?.groupId !== Entities.GroupsStore.activeGroupId;
    },

    get isQuoteTextMode(): boolean {
      return (
        Boolean(presenter.quote) && Boolean(this.quote?.messageId) && Boolean(this.quote?.senderId)
      );
    },

    onClick(): void {
      if (!presenter.isQuoteTextMode) {
        return;
      }
      Tasks.messaging.highlightMessageText({
        groupId: presenter.quote!.groupId || '',
        messageId: presenter.quote!.messageId || '',
        text: presenter.quote!.text,
      });
    },

    endQuote(): void {
      Tasks.messaging.endQuote(null);
    },
  }));

  return presenter;
}
